import { CSSObject } from "@emotion/react";
import { mediaQueryStyles } from "@newsela/angelou";

import { SEARCH_PAGE_BREAKPOINTS } from "@/search/Langston/SearchPage/SearchPage.constants";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const sortByVisibilityCss: CSSObject = {
  display: "none",

  [breakpoint.upTo(SEARCH_PAGE_BREAKPOINTS.MD)]: {
    display: "flex",
  },
};
